var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RNavWorldEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,10 L18,6 L30,10 L42,6 L42,32 L30,36 L18,32 L6,36 Z",
    fill: "#F7F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,6 L18,32 L20,32.7 L20,6.7 Z",
    fill: "#7C1CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10 L30,36 L28,35.3 L28,9.3 Z",
    fill: "#00D4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16 C12,13 16,13 19,15 C22,17 25,15 27,13 C31,10 36,11 39,14 L39,19 C36,17 34,17 31,19 C28,21 24,22 21,20 C17,17 14,18 9,21 Z",
    fill: "#2A0D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12,27 C16,22 21,20 26,20 C31,20 36,22 40,27 C36,32 31,34 26,34 C21,34 16,32 12,27 Z",
    fill: "#0D0D12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15,27 C18.3,23.8 22,22.3 26,22.3 C30,22.3 33.7,23.8 37,27 C33.7,30.2 30,31.7 26,31.7 C22,31.7 18.3,30.2 15,27 Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26,23.5 A3.5,3.5 0,1 0,26,30.5 A3.5,3.5 0,1 0,26,23.5",
    fill: "#00D4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26,25 A2,2 0,1 0,26,29 A2,2 0,1 0,26,25",
    fill: "#7C1CFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1,25.4 A0.8,0.8 0,1 0,27.1,27 A0.8,0.8 0,1 0,27.1,25.4",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RNavWorldEye);
export default __webpack_public_path__ + "static/media/p4r_nav_world_eye.0c10f30f4c6718870db807e8edec6220.svg";
export { ForwardRef as ReactComponent };